import { Directive, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Validator, AbstractControl, Validators, NG_VALIDATORS, ValidationErrors } from '@angular/forms';


@Directive({
    selector: '[appNoWhitespaceValidator]',
    providers: [{ provide: NG_VALIDATORS, useExisting: NoWhitespaceValidator, multi: true }]
})
export class NoWhitespaceValidator implements Validator {
    static Validator = (c: AbstractControl): ValidationErrors => {
        if (c.value)
            return c.value.trim().length === 0 ? { 'whitespace': true } : null;
        return null;
    }
    validate(c: AbstractControl): ValidationErrors {
        if (c.value)
            return c.value.trim().length === 0 ? { 'whitespace': true } : null;
        return null;
    }
}

